import React from 'react';
import styles from './AnimatedLoadingScreen.module.css';
import Logo from '../../Logo/Logo';
import BrandName from '../../BrandName/BrandName';

const AnimatedLoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div className={styles.loadingContainer}>
      {/* Centered Logo */}
      <div className={styles.logoWrapper}>
        <Logo
          className={styles.logo}
          imgClassName=""
          tmClassName="-bottom-0.5 -right-1.5 text-[0.55rem] sm:text-[0.65rem]"
        />
      </div>
      
      {/* Bottom Section - App Name and Loading Bar */}
      <div className={styles.bottomSection}>
        <p className={styles.appName}><BrandName /></p>
        <div className={styles.loadingBarContainer}>
          <div className={styles.loadingBar}></div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedLoadingScreen;
